import React from 'react';
import { Box, Typography } from '@mui/material';
import { Task, TaskStatus } from '../../types/Task';
import { taskBaseColor, getTaskProgress } from '../../utility/task';
import TaskProgress from './TaskProgress';
import _ from 'lodash';

type Props = {
  task: Task;
};

export default function TaskStatusProgress({ task }: Props) {
  const { completed, inProgress, total } = getTaskProgress(task);

  const statusColor = taskBaseColor(task.status);
  const formattedStatus = _.startCase(task.status);

  return (
    <Box sx={{ minWidth: 200 }}>
      {/* Top Row */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {/* Status */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: '50%',
              backgroundColor: statusColor,
            }}
          />
          <Typography variant="body2">{formattedStatus}</Typography>
        </Box>

        {/* Progress Numbers */}
        <Typography variant="body2" fontWeight={500}>
          {completed}/{total}
          {inProgress > 0 && (
            <Box
              component="span"
              sx={{
                color: taskBaseColor(TaskStatus.IN_PROGRESS),
                ml: 0.5,
              }}
            >
              ({inProgress})
            </Box>
          )}
        </Typography>
      </Box>

      {/* Progress Bar */}
      <Box sx={{ mt: 0.5 }}>
        <TaskProgress task={task} />
      </Box>
    </Box>
  );
}
